import { TimerDark, TimerLight } from "assets/icons"
import classNames from "classnames"
import { useTranslation } from "react-i18next"
import { useIsMobileDevice } from "utils/hooks"

const ChatTimeWarningProgress = ({ timeLeft }) => {
    const isMobile = useIsMobileDevice()
    const { t } = useTranslation()
    const fillPercent = (timeLeft / 60) * 100

    return timeLeft <= 60 ? (
        <div className="w-full flex flex-col items-stretch mb-3">
            <div className="flex justify-between">
                <span className="flex items-center mb-2">
                    {
                        isMobile ? <TimerLight /> : <TimerDark />
                    }
                    <p className="uppercase text-xs text-[#F4F4F4] sm:text-[#3D2F52] font-normal sm:font-medium opacity-50 ml-1 mr-1">
                        {t("chat.ending_in")}...
                    </p>
                </span>
                <p className="font-semibold text-base text-white sm:text-bistre">
                    {
                        timeLeft === 0
                            ? `0:00`
                            : new Date(timeLeft * 1000).toISOString().substr(14, 5)
                    }
                </p>
            </div>
            <div className={`relative h-[8px] overflow-hidden rounded-2xl bg-gray-800 sm:bg-gray-200 text-center`}>
                <div
                    className={classNames(
                        "absolute h-full w-full rounded-2xl bg-[#F55] transition-all"
                    )}
                    style={{ width: fillPercent + "%" }}
                />
            </div>
        </div>
    ) : <></>
}

export default ChatTimeWarningProgress